export class Query {
  constructor(
    public dateRangeData: any,
    public facetData: any,
    public parameterData: any,
    public recordTotalQuantity: number,
    public searchText: string,
    public sortDataBag: any[],
    public recordStartNumber: number
  ) {}
}
